import { useTranslation } from 'react-i18next';
import { Button, Select } from '../ui';
import { MISSION_ORIGINS } from '../../context/MissionContext';

/**
 * Origin + topic filters for the Mission Center (spec §10.3).
 *
 * Filtering happens client-side over the already-loaded list: the whole point
 * of the Mission Center is a fast overview, and a round-trip per dropdown
 * change would make the three sections flicker between loading states. The
 * REST layer keeps its `?origin=&topic=` parameters for deep links and for
 * lists too large to hold at once.
 */
export function MissionFilters({ filters, topics, onChange, resultCount }) {
  const { t } = useTranslation();
  const isFiltered = filters.origin !== 'all' || filters.topic !== 'all';

  return (
    <div className="etch-mission-filters">
      <Select
        label={t('missions.filterOrigin')}
        value={filters.origin}
        onChange={(event) => onChange({ ...filters, origin: event.target.value })}
        options={[
          { value: 'all', label: t('missions.filterAll') },
          ...MISSION_ORIGINS.map((origin) => ({
            value: origin,
            label: t([`missions.origin.${origin}`, 'missions.title']),
          })),
        ]}
      />

      <Select
        label={t('missions.filterTopic')}
        value={filters.topic}
        disabled={topics.length === 0}
        hint={topics.length === 0 ? t('missions.noTopicsHint') : undefined}
        onChange={(event) => onChange({ ...filters, topic: event.target.value })}
        options={[
          { value: 'all', label: t('missions.filterAll') },
          ...topics.map((topic) => ({ value: topic, label: topic })),
        ]}
      />

      {isFiltered && (
        <Button
          variant="ghost"
          size="compact"
          className="etch-mission-filters__reset"
          onClick={() => onChange({ origin: 'all', topic: 'all' })}
        >
          {t('missions.filterReset')}
        </Button>
      )}

      <p className="etch-visually-hidden" role="status" aria-live="polite">
        {t('missions.filterResultCount', { count: resultCount })}
      </p>
    </div>
  );
}

export default MissionFilters;
